import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import MovieIcon from '@mui/icons-material/Movie';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

function EmptyWatchlistsFree() {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
        <p><strong>Watchlists</strong></p>
        <div>
          <Button
            href="/pricing"
            size="small"
            variant="outlined"
            startIcon={<MovieIcon />}
          >
            Create a watchlist
          </Button>
        </div>
      </p>
    </div>
  );
}

export default EmptyWatchlistsFree;
